module.exports = __webpack_public_path__ + "img/744.a3f8026b.jpg";